export default __webpack_public_path__ + "static/media/kitchen2-1440w.dc5ad376.png";